// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floatingMenu_mHB_kdzyXGELQoLEZSyz {
  position: fixed;
  bottom: var(--hc-size-spacing-2);
  left: var(--hc-size-spacing-2);
  right: var(--hc-size-spacing-2);
  z-index: 3;
}

@media (min-width: 768px) {
  .floatingMenu_mHB_kdzyXGELQoLEZSyz {
    bottom: var(--hc-size-spacing-7);
    left: var(--hc-size-spacing-6);
    right: var(--hc-size-spacing-6);
    max-width: calc(100vw - var(--menu-left-offset));
  }
}

@media (min-width: 992px) and (max-width: 1292px) {
  .floatingMenu_mHB_kdzyXGELQoLEZSyz {
    max-width: 100vw;
  }
}

@media (min-width: 1280px) {
  .floatingMenu_mHB_kdzyXGELQoLEZSyz {
    left: calc(var(--menu-left-offset) + 6rem);
    right: 6rem;
  }
}

@media (min-width: 1536px) {
  .floatingMenu_mHB_kdzyXGELQoLEZSyz {
    left: calc(var(--menu-left-offset) + 10rem);
    right: 10rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/contentList/components/bulkActions/floatingMenu.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE;IACE,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,WAAW;EACb;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF","sourcesContent":[".floatingMenu {\n  position: fixed;\n  bottom: var(--hc-size-spacing-2);\n  left: var(--hc-size-spacing-2);\n  right: var(--hc-size-spacing-2);\n  z-index: 3;\n}\n\n@media (min-width: 768px) {\n  .floatingMenu {\n    bottom: var(--hc-size-spacing-7);\n    left: var(--hc-size-spacing-6);\n    right: var(--hc-size-spacing-6);\n    max-width: calc(100vw - var(--menu-left-offset));\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1292px) {\n  .floatingMenu {\n    max-width: 100vw;\n  }\n}\n\n@media (min-width: 1280px) {\n  .floatingMenu {\n    left: calc(var(--menu-left-offset) + 6rem);\n    right: 6rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .floatingMenu {\n    left: calc(var(--menu-left-offset) + 10rem);\n    right: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var floatingMenu = `floatingMenu_mHB_kdzyXGELQoLEZSyz`;
export default ___CSS_LOADER_EXPORT___;
